// eslint-disable-next-line import/no-extraneous-dependencies
import '@babel/polyfill';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import firebase from 'firebase';
import App from './App.vue';
import router from './router';

// Vue.component('multiselect', Multiselect)

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyDjsEQL64uhCTiX6YfiDG7g-xqSC7KIrtk',
    authDomain: 'teach-tech-nc-2346c.firebaseapp.com',
    databaseURL: 'https://teach-tech-nc-2346c-default-rtdb.firebaseio.com',
    projectId: 'teach-tech-nc-2346c',
    storageBucket: 'teach-tech-nc-2346c.appspot.com',
    messagingSenderId: '812238937576',
    appId: '1:812238937576:web:9588ff1a259935fbc8585d',
    measurementId: 'G-FN7KVWMY6Q',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);

Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
